/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum PricingMethodType {
    MaterialOnly = 0,
    HaulOnly = 1,
    Standard = 2,
}
